import type { Scaffold as PageScaffold } from "@Light/components/page/scaffold";
import { BrandMode } from "@Light/services/lightTypes";

export function formatDecimal(value: string): string {
  return Intl.NumberFormat("en-US", { maximumFractionDigits: 2 }).format(
    parseFloat(value),
  );
}

export function stripTrailingDecimalZeros(s: string): string {
  if (!s.includes(".")) return s;
  return s.replace(/0+$/, "").replace(/\.$/, "");
}

export function formatPlanName(name: string): string {
  if (name.toLowerCase().endsWith(" plan")) {
    return name;
  }
  return `${name} Plan`;
}

export function formatBrandedPlanName(
  page: Pick<PageScaffold, "companyName" | "brandMode">,
  planName: string,
): string {
  const formatted = formatPlanName(planName);
  if (page.brandMode === BrandMode.Subtle) {
    return formatted;
  }
  return `${page.companyName} ${formatted}`;
}
